import { createContext } from 'react';

import type { BackgroundColor } from '../constants';
import type { MotifScheme } from '../motif';

export const BlockBackgroundColorContext = createContext<BackgroundColor | MotifScheme | undefined>(
  undefined
);
